import type { IModule, ModuleContext } from '@punica/editor';
import { ModuleLifecycleState } from '@punica/editor';
import { MODULE_NAMES } from '@punica/editor';

/**
 * Shell ViewRegistry module — the single visibility authority
 * (`punica.shell.Views.manager`). Depends on the layout so view hosts
 * can be materialized/shown, and on kernel.commands for the transitional
 * fallback-command path.
 */
export class ViewsModule implements IModule {
  readonly name = MODULE_NAMES.SHELL.VIEWS;
  readonly version = '1.0.0';
  readonly dependencies: readonly string[] = [
    MODULE_NAMES.SHELL.LAYOUT,
    MODULE_NAMES.KERNEL.COMMANDS
  ];

  #state: ModuleLifecycleState = ModuleLifecycleState.CREATED;

  get state(): ModuleLifecycleState {
    return this.#state;
  }

  async bootstrap(context: ModuleContext): Promise<void> {
    const { punica, registry } = context;

    const layoutState = registry.getState(MODULE_NAMES.SHELL.LAYOUT);
    if (layoutState !== ModuleLifecycleState.BOOTSTRAPPED) {
      throw new Error('shell.layout must be bootstrapped before shell.views');
    }

    if (!(punica.shell as any)?.Views?.manager) {
      throw new Error('Views API not available');
    }
  }

  async start(_context: ModuleContext): Promise<void> {
    // ViewRegistry is ready to use after bootstrap.
  }
}
